<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <!-- <el-col :span="6">
            <el-form-item label="养老院名称" prop="nursinghomeId">
              <el-select
                v-model="searchForm.nursinghomeId"
                style="width: 100%"
                placeholder="养老院名称"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

        <el-col :span="6">
          <el-form-item label="活动主题" prop="theme">
            <el-input
              clearable
              v-model="searchForm.theme"
              placeholder="活动主题"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="活动分类" prop="activityType">
            <el-select v-model="searchForm.activityType" style="width: 100%" placeholder="活动分类">
              <el-option
                v-for="(item, index) in activityTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发布状态" prop="pushStatus">
            <el-select v-model="searchForm.pushStatus" style="width: 100%" placeholder="发布状态">
              <el-option
                v-for="(item, index) in pushStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="显示状态" prop="showStatus">
            <el-select v-model="searchForm.showStatus" style="width: 100%" placeholder="显示状态">
              <el-option
                v-for="(item, index) in showStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="活动举办人" prop="holdPersonName">
            <el-input
              clearable
              v-model="searchForm.holdPersonName"
              placeholder="活动举办人"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="活动时间" prop="daterange">
            <el-date-picker
              v-model="searchForm.daterange"
              style="width: 100%;"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="活动状态" prop="activityStatus">
            <el-select
              v-model="searchForm.activityStatus"
              style="width: 100%"
              placeholder="活动状态"
            >
              <el-option
                v-for="(item, index) in activityStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button v-if="permissionList.addBtn" type="primary" size="small" @click="addNursingForm">
          新 增</el-button
        >
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          v-if="permissionList.viewBtn"
          size="small"
          @click="viewFun(scope.row)"
          >查看
        </el-button>
        <el-button
          type="text"
          v-if="Number(scope.row.activityStatus) !== 3 && permissionList.editBtn"
          size="small"
          @click="editRecord(scope.row)"
          >编辑
        </el-button>
        <el-button
          type="text"
          v-if="scope.row.showStatus == 1 && permissionList.noshowBtn"
          size="small"
          @click="noVisible(scope.row)"
          >不显示
        </el-button>
        <el-button
          type="text"
          v-if="scope.row.showStatus == 0 && permissionList.showBtn"
          size="small"
          @click="visible(scope.row)"
          >显示
        </el-button>
        <el-button
          type="text"
          v-if="scope.row.showStatus == null && permissionList.pushBtn"
          size="small"
          @click="pushActive(scope.row)"
          >发布
        </el-button>
        <el-button
          type="text"
          v-if="
            scope.row.activityStatus == 3 && scope.row.showStatus == 1 && permissionList.zongjieBtn
          "
          size="small"
          @click="activeSummarize(scope.row)"
          >活动总结
        </el-button>
        <el-button
          type="text"
          v-if="
            scope.row.activityStatus == 3 && scope.row.showStatus == 1 && permissionList.huiguBtn
          "
          size="small"
          @click="wonderfulReview(scope.row)"
          >精彩回顾
        </el-button>
        <el-button
          type="text"
          v-if="scope.row.showStatus == null && permissionList.deletBtn"
          size="small"
          @click="deleteFun(scope.row)"
          >删除
        </el-button>
        <el-button        
          type="text"
          v-if="scope.row.personNum > 0 && permissionList.exportPeopleBtn"
          size="small"
          @click="exportFun(scope.row)"
          >导出人员
        </el-button>
      </template>
    </avue-crud>

    <itemList ref="itemList"></itemList>
    <hr-dialog
      :title="formModel === 'add' ? '新增' : formModel === 'edit' ? '编辑' : '查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <activeForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></activeForm>
      </template>
    </hr-dialog>
    <hr-dialog
      title="活动总结"
      :allowFull="false"
      width="60%"
      :visible.sync="activeSummarizeVisible"
    >
      <template slot="body">
        <activeSummarize
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="activeSummarizeVisible"
          @success="recordSuccess"
        ></activeSummarize>
      </template>
    </hr-dialog>
    <hr-dialog
      title="精彩回顾"
      :allowFull="false"
      width="60%"
      :visible.sync="activeWonderfulVisible"
    >
      <template slot="body">
        <activeWonderful
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="activeWonderfulVisible"
          @success="recordSuccess"
        ></activeWonderful>
      </template>
    </hr-dialog>
  </basic-container>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import { getnursinghomeIdList } from '@/api/crmedical/project/project';
import { activityManagePage, notShow, remove, pushAct, show } from '@/api/goldHousekeep/index';
import activeForm from './activeNewForm.vue';
import activeSummarize from './activeSummarize.vue';
import activeWonderful from './activeWonderful.vue';
import searchFromShow from '@/components/search-form-show/index';
import { getToken } from '@/util/auth';
import { mapGetters } from 'vuex';

export default {
  components: { searchFromShow, activeForm, activeSummarize, activeWonderful },
  data() {
    return {
      activeWonderfulVisible: false,
      activeSummarizeVisible: false,
      activityStatusList: [],
      activityTypeList: [],
      pushStatusList: [
        {
          dictValue: '未发布',

          dictKey: 0,
        },
        {
          dictValue: '已发布',

          dictKey: 1,
        },
      ],
      showStatusList: [
        {
          dictValue: '不显示',

          dictKey: 0,
        },
        {
          dictValue: '显示',

          dictKey: 1,
        },
      ],
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      nursingFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        theme: '',
        daterange: [],
        projectType: '1',
        activityType: '',
        pushStatus: '',
        showStatus: '',
        activityStatus: '',
      },

      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          // {
          //   label: '养老院名称',
          //   prop: 'warehouseName',
          // },
          // {
          //   label: '活动名称',
          //   prop: 'theme',
          // },
          {
            label: '活动主题',
            prop: 'theme',
          },
          {
            label: '活动分类',
            prop: 'activityType',
            type: 'select',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_activity_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '副标题',
            prop: 'subtitle',
          },
          {
            label: '活动地点',
            prop: 'activityAddress',
            // type: 'select',

            // dicUrl: '/api/nursing/getNursinghome',
            // props: {
            //   label: 'name',
            //   value: 'id',
            // },
          },
          {
            label: '活动时间',
            prop: 'activityTime',
          },
          {
            label: '活动内容简述',
            prop: 'resume',
          },
          {
            label: '活动举办人',
            prop: 'holdPersonName',
          },
          {
            label: '活动联系电话',
            prop: 'phone',
          },
          {
            label: '排序',
            prop: 'sort',
          },
          {
            label: '活动状态',
            prop: 'activityStatus',
            type: 'select',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_activity_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '发布状态',
            prop: 'pushStatus',
            type: 'select',
            dataType: 'number',
            dicData: [
              {
                dictKey: 0,
                dictValue: '未发布',
              },
              {
                dictKey: 1,
                dictValue: '已发布',
              },
            ],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '是否显示',
            prop: 'showStatus',
            type: 'select',
            dataType: 'number',
            dicData: [
              {
                dictKey: 0,
                dictValue: '不显示',
              },
              {
                dictKey: 1,
                dictValue: '显示',
              },
            ],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      nursinghomeIdList: [],
      userList: [],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.jinguanjia_view, false),
        editBtn: this.vaildData(this.permission.jinguanjia_edit, false),
        addBtn: this.vaildData(this.permission.jinguanjia_add, false),
        showBtn: this.vaildData(this.permission.jinguanjia_show, false),
        pushBtn: this.vaildData(this.permission.jinguanjia_push, false),
        noshowBtn: this.vaildData(this.permission.jinguanjia_noshow, false),
        zongjieBtn: this.vaildData(this.permission.jinguanjia_zongjie, false),
        huiguBtn: this.vaildData(this.permission.jinguanjia_huigu, false),
        deletBtn: this.vaildData(this.permission.jinguanjia_delet, false),
        exportPeopleBtn: this.vaildData(this.permission.jinguanjia_exportPeople, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
    self.$refs.crud.doLayout();
    window.onresize = () => {
      self.$refs.crud.doLayout();
    };
  },
  activated() {
    console.log('activated=======================');
    this.$refs.crud.doLayout();
  },
  methods: {
    wonderfulReview(row) {
      this.formRow = row;
      this.activeWonderfulVisible = true;
    },
    activeSummarize(row) {
      this.formRow = row;
      this.activeSummarizeVisible = true;
    },
    openItemDetail(row) {
      this.$refs.itemList.openItemListOnload(row.id, row.name);
    },
    addNursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },
    visible(row) {
      this.$confirm(' 是否变为显示?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          show(row.id).then((re) => {
            this.$message.success('操作成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    noVisible(row) {
      this.$confirm(' 是否变为不显示?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          notShow(row.id).then((re) => {
            this.$message.success('操作成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    pushActive(row) {
      this.$confirm(' 是否发布该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          pushAct(row.id).then((re) => {
            this.$message.success('发布成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    deleteFun(row) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          remove(row.id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    viewFun(row) {
      this.formModel = 'view';

      this.formRow = row;
      this.nursingFormVisible = true;
    },
    editRecord(row) {
      this.formModel = 'edit';

      this.formRow = row;
      this.nursingFormVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      this.editVisible = false;
      this.activeSummarizeVisible = false;
      this.activeWonderfulVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.editVisible = false;
      this.activeWonderfulVisible = false;
      this.activeSummarizeVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    viewRecord(row) {
      this.alarmRuleTittle = '查看';
      this.rowInfo = row;

      this.alarmRuleModel = 'view';
      this.alarmRuleVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        nursinghomeId: this.searchForm.nursinghomeId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    nursinghomeIdChange(nursinghomeId) {
      this.searchForm.warehouseId = '';
      this.warehouseList = [];
      getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
        this.warehouseList = res.data;
      });
      // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
      // //           this.canteenList = res.data
      // //        })
      // this.getDeptList(this.searchForm.nursinghomeId);
      // this.getCanteen(this.searchForm.nursinghomeId);
    },
    // 导出人员
    exportFun(row) {
      const id = row.id;
      this.$confirm('是否确认导出人员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        const parm = {
          id: id,
        };
        // 将条件参数拼接为路由传参格式
        let paramFormString = this.tool.objToform(parm);
        this.tool.downloadFile(
          `/api/v4ward/activity/manage/export-person?${
            this.website.tokenHeader
          }=${getToken()}&${paramFormString}`,
          'abc.xlsx',
          'xlsx/xls'
        );
      });
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.daterange && this.searchForm.daterange.length > 0) {
        this.searchForm.searchStartTime = this.dayjs(this.searchForm.daterange[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.searchEndTime = this.dayjs(this.searchForm.daterange[1]).format(
          'YYYY-MM-DD 23:59:59'
        );
      } else {
        this.searchForm.searchStartTime = '';
        this.searchForm.searchEndTime = '';
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.projectType = '1';
    },
    // 调整表格高度
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 10;
    },
    initData() {
      // getNursinghome().then((res) => {
      //   this.nursinghomeIdList = res.data;
      //   if (this.nursinghomeIdList.length > 0) {
      //     this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
      //     // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
      //     //   this.warehouseList = res.data;
      //     // });
      //     getNursingList({ id: this.searchForm.nursinghomeId }).then((res) => {
      //       this.userList = res.data;
      //     });
      //     this.onLoad();
      //   }
      // });
      getDictionary('nursinghome_activity_status').then((res) => {
        this.activityStatusList = res.data;
      });
      getDictionary('nursinghome_activity_type').then((res) => {
        this.activityTypeList = res.data;
      });
    },

    onLoad() {
      this.loading = true;

      activityManagePage(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          this.searchForm
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
<style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
